import React from "react";
import _ from "underscore";
import PropTypes from "prop-types";
import ActionLogger from "action-logger";
import Constants from "rtr-constants";
import objectToQueryString from "modules/object-to-query-string";
import productsActions from "actions/products-actions";
import SpecialSelect from "components/source/new_taxonomy/special-select";
import { withQueryParams } from "../hoc/with-query-params";

class SortDropdown extends React.Component {
  static propTypes = {
    defaultLabel: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    dropdownValues: PropTypes.shape({
      [Constants.sortKeys.RECOMMENDED]: PropTypes.string,
      [Constants.sortKeys.NEWEST]: PropTypes.string,
      [Constants.sortKeys.PRICE_DESC]: PropTypes.string,
      [Constants.sortKeys.PRICE_ASC]: PropTypes.string,
    }),
    onChangeSort: PropTypes.func,
    path: PropTypes.string.isRequired,
    queryParams: PropTypes.shape({
      filters: PropTypes.object,
      sort: PropTypes.string,
    }),
    sort: PropTypes.string.isRequired,
  };

  static defaultProps = {
    dropdownValues: {
      [Constants.sortKeys.RECOMMENDED]: "Sort by Recommended",
      [Constants.sortKeys.NEWEST]: "Sort by Newest",
      [Constants.sortKeys.PRICE_DESC]: "Sort by Price (high to low)",
      [Constants.sortKeys.PRICE_ASC]: "Sort by Price (low to high)",
    },
    onChangeSort: _.noop,
  };

  state = {
    selectedSort: this.props.sort,
  };

  onChangeSort = sort => {
    const newParams = _.extend({}, this.props.queryParams, { sort: sort });
    const path = this.props.path + "?" + objectToQueryString(newParams);
    const prevSort = this.props?.sort ?? "";

    this.props.dispatch(productsActions.navigateToSort(path, sort));
    this.setState({ selectedSort: sort });
    this.props.onChangeSort(sort);

    ActionLogger.logAction({
      object_type: "grid",
      action: "grid_sort",
      sort_type: sort,
      sort_type_from: prevSort,
    });
  };

  render() {
    return (
      <SpecialSelect
        id="filters-sort"
        name="filters[sort]"
        label="Sort by"
        defaultLabel={this.props.defaultLabel}
        onChange={this.onChangeSort}
        selected={this.state.selectedSort}
        sorts={this.props.dropdownValues}
      />
    );
  }
}

export default withQueryParams()(SortDropdown);
